import { Box } from '@mui/material'

import { FCWithChildren } from '@/types'

type TabPanelProps = {
  index: number
  value: number
  title: string
}

const TabPanel: FCWithChildren<TabPanelProps> = ({
  children,
  title,
  value,
  index
}) => (
  <Box
    role="tabpanel"
    hidden={value !== index}
    id={`${title}-tabpanel-${index}`}
    aria-labelledby={`${title}-tab-${index}`}
  >
    {value === index && children}
  </Box>
)

export default TabPanel
